import { SxProps, Theme, Box } from '@mui/material';

import { ChatBox } from './ChatBox';
import { InfoBox } from './InfoBox';

type OfficeHoursContentProps = Readonly<{
  superuser: boolean;
  supercoach: boolean;
}>;

export const OfficeHoursContent = ({ superuser, supercoach }: OfficeHoursContentProps) => {
  return (
    <Box
      sx={{
        ...container,
        ...(supercoach
          ? { gridTemplateColumns: '1.1fr 5px 1.3fr' }
          : { gridTemplateColumns: '1fr 5px 1.3fr' }),
      }}
    >
      <Box sx={paddedBox}>
        <ChatBox superuser={superuser} supercoach={supercoach} />
      </Box>
      <Box sx={divider} />
      <Box sx={paddedBox}>
        <InfoBox />
      </Box>
    </Box>
  );
};

const container: SxProps<Theme> = {
  display: 'grid',
  gridTemplateColumns: '1fr 5px 1.3fr',
  flexDirection: 'row',
  width: '100%',
  px: 4,
  '@media (max-width: 1015px)': {
    height: 'calc(100vh - 60px)',
  },
  '@media (max-width: 900px)': {
    gridTemplateColumns: '1fr',
    gridTemplateRows: 'auto',
    overflowY: 'scroll',
    width: 'calc(100vw - 100px)',
  },
};

const divider: SxProps<Theme> = {
  backgroundColor: 'red',
  width: '1px',
  height: '100%',
  marginLeft: '34px',
  '@media (max-width: 900px)': {
    display: 'none',
  },
};

const paddedBox: SxProps<Theme> = {
  paddingTop: '16px',
  marginBottom: '22px',
};
